import React, { useState } from "react";
import {
  AreaSeries,
  HorizontalGridLines,
  GradientDefs,
  VerticalGridLines,
  XAxis,
  XYPlot,
  YAxis,
  Crosshair,
  makeWidthFlexible,
  DiscreteColorLegend,
  LineMarkSeries
} from "react-vis";
import moment from 'moment';
const trimSet = (arr) => {
  if(arr.length<10) return arr;
  const X = parseInt(arr.length/10);
  return arr.filter(function(v) {
    return moment(v).format("DD")=="01";
});
}

export default class Multiple extends React.Component {
  state = {
    crosshairValues: []
  };
  static getDerivedStateFromProps(props){
    const DATA = props.data.map(series => {
      return series.map(elem => {
        return { ...elem, x: new Date(elem.x * 1000) };
      });
    });
    return {
      DATA
    }
  }
  _onMouseLeave = () => {
    this.setState({ crosshairValues: [] });
  };
  _onNearestX = (value, { index }) => {
    this.setState({ crosshairValues: this.state.DATA.map(d => d[index]) });
  };
  render() {
    const FlexibleXYPlot = makeWidthFlexible(XYPlot);
    return (
      <>
        <DiscreteColorLegend
          className="viz-offset flexLegend"
          orientation="horizontal"
          items={this.props.items}
        />
        <FlexibleXYPlot
          margin={{ left: 100, right:100 }}
          height={300}
          xType = "time"
          onMouseLeave={this._onMouseLeave}
        >
          <VerticalGridLines />

          <XAxis tickFormat={v => moment(v).format("MMM DD")} tickValues={trimSet(this.state.DATA[0].map(d=>d.x))}/>
          <YAxis hideLine />
          {this.state.DATA.map((series,i)=><LineMarkSeries curve={'curveMonotoneX'} key={i} data={series} onNearestX={i===0?this._onNearestX:()=>{}}/>)} 
          <Crosshair
            values={this.state.crosshairValues}
          >
            <div className="label-wrapper">
              {this.props.items.map((item,index)=>( 
              <div key={index}>
                <div className="label-title">{this.props.items[index]}</div>
                <div className="label-value">{this.state.crosshairValues[index] && parseInt(this.state.crosshairValues[index].y)}</div>
              </div>))}
            </div>
          </Crosshair>
        </FlexibleXYPlot>
      </>
    );
  }
}
